import React, { Component } from "react";

export default class TabPanel extends Component {
    render() {
        const { value, index } = this.props;
        return <>{value === index && this.props.children}</>;
    }
}
